import { PERMISSIONS, type PermissionValue } from '@tiles-erp/config';

/** Permission required to open each sidebar destination. Mirrors its primary read endpoint. */
export const MENU_PERMISSIONS: Record<string, PermissionValue> = {
  '/': PERMISSIONS.DASHBOARD_READ,
  '/quotations': PERMISSIONS.QUOTATION_READ,
  '/sales-orders': PERMISSIONS.SALES_ORDER_READ,
  '/sales-invoices': PERMISSIONS.SALES_INVOICE_READ,
  '/delivery-slips': PERMISSIONS.DELIVERY_SLIP_PRINT,
  '/sales-returns': PERMISSIONS.SALES_RETURN_READ,
  '/collections': PERMISSIONS.RECEIPT_READ,
  '/outstanding': PERMISSIONS.CUSTOMER_LEDGER_READ,
  '/advances': PERMISSIONS.CUSTOMER_LEDGER_READ,
  '/customer-ledger': PERMISSIONS.CUSTOMER_LEDGER_READ,
  '/purchase-orders': PERMISSIONS.PURCHASE_ORDER_READ,
  '/delivery-addresses': PERMISSIONS.PURCHASE_ORDER_READ,
  '/goods-receipts': PERMISSIONS.GRN_READ,
  '/purchase-invoices': PERMISSIONS.PURCHASE_INVOICE_READ,
  '/purchase-returns': PERMISSIONS.PURCHASE_RETURN_READ,
  '/supplier-payments': PERMISSIONS.SUPPLIER_PAYMENT_READ,
  '/payables': PERMISSIONS.SUPPLIER_LEDGER_READ,
  '/supplier-ledger': PERMISSIONS.SUPPLIER_LEDGER_READ,
  '/granite-stock': PERMISSIONS.STOCK_READ,
  '/granite-invoice': PERMISSIONS.SALES_INVOICE_CREATE,
  '/stock/branch-godown-report': PERMISSIONS.STOCK_READ,
  '/stock': PERMISSIONS.STOCK_READ,
  '/stock/check': PERMISSIONS.STOCK_READ,
  '/stock/product-check': PERMISSIONS.STOCK_READ,
  '/stock/product-activity': PERMISSIONS.STOCK_READ,
  '/stock/count': PERMISSIONS.STOCK_READ,
  '/stock/verification-report': PERMISSIONS.STOCK_READ,
  '/stock/smart-check': PERMISSIONS.STOCK_READ,
  '/stock/transfers': PERMISSIONS.STOCK_READ,
  '/stock/reports': PERMISSIONS.STOCK_READ,
  '/stock/godown-report': PERMISSIONS.STOCK_READ,
  '/stock/multiple-godowns': PERMISSIONS.STOCK_READ,
  '/stock/inactive-products': PERMISSIONS.STOCK_READ,
  '/product-audit': PERMISSIONS.PRODUCT_READ,
  '/gate-passes': PERMISSIONS.GATE_PASS_READ,
  '/driver-cash': PERMISSIONS.DRIVER_CASH_READ,
  '/dispatch-reports': PERMISSIONS.DISPATCH_REPORT_READ,
  '/accounts': PERMISSIONS.CASH_BOOK_READ,
  '/cash-book': PERMISSIONS.CASH_BOOK_READ,
  '/day-close': PERMISSIONS.CASH_BOOK_READ,
  '/owner-statement': PERMISSIONS.CASH_BOOK_READ,
  '/expense-heads': PERMISSIONS.CASH_BOOK_READ,
  '/gst-summary': PERMISSIONS.GST_REPORT_READ,
  '/purchase-gst': PERMISSIONS.GST_REPORT_READ,
  '/profit': PERMISSIONS.PROFIT_REPORT_READ,
  '/reports/product-transactions': PERMISSIONS.PROFIT_REPORT_READ,
  '/reports/fast-moving': PERMISSIONS.PROFIT_REPORT_READ,
  '/reports/product-sales': PERMISSIONS.PROFIT_REPORT_READ,
  '/reports/godown-sales': PERMISSIONS.PROFIT_REPORT_READ,
  '/reports/salesman-incentives': PERMISSIONS.INCENTIVE_READ,
  '/reports/incentive-products': PERMISSIONS.INCENTIVE_READ,
  '/products/incentives': PERMISSIONS.INCENTIVE_MANAGE,
  '/reports/salesman-sales': PERMISSIONS.PROFIT_REPORT_READ,
  '/crm': PERMISSIONS.CRM_LEAD_READ,
  '/crm/campaigns': PERMISSIONS.CRM_CAMPAIGN_READ,
  '/crm/visits': PERMISSIONS.CRM_VISIT_READ,
  '/customers': PERMISSIONS.CUSTOMER_READ,
  '/suppliers': PERMISSIONS.SUPPLIER_READ,
  '/products': PERMISSIONS.PRODUCT_READ,
  '/products/rates': PERMISSIONS.PRICE_READ,
  '/products/prices': PERMISSIONS.PRICE_READ,
  '/products/weights': PERMISSIONS.PRODUCT_READ,
  '/catalog/categories': PERMISSIONS.CATEGORY_READ,
  '/catalog/brands': PERMISSIONS.BRAND_READ,
  '/catalog/series': PERMISSIONS.SERIES_READ,
  '/catalog/collections': PERMISSIONS.COLLECTION_READ,
  '/transporters': PERMISSIONS.TRANSPORTER_READ,
  '/vehicles': PERMISSIONS.VEHICLE_READ,
  '/drivers': PERMISSIONS.DRIVER_READ,
  '/users': PERMISSIONS.USER_READ,
  '/roles': PERMISSIONS.ROLE_READ,
  '/departments': PERMISSIONS.DEPARTMENT_READ,
  '/organization/companies': PERMISSIONS.COMPANY_READ,
  '/organization/branches': PERMISSIONS.BRANCH_READ,
  '/organization/warehouses': PERMISSIONS.GODOWN_READ,
  '/organization/godowns': PERMISSIONS.GODOWN_READ,
  '/organization/gates': PERMISSIONS.GATE_READ,
  '/organization/racks': PERMISSIONS.RACK_READ,
  '/number-series': PERMISSIONS.SETTINGS_MANAGE,
  '/portal-access': PERMISSIONS.PORTAL_ACCOUNT_MANAGE,
  '/audit': PERMISSIONS.AUDIT_READ,
  '/sixorbit': PERMISSIONS.SIXORBIT_CONFIGURE,
  '/sixorbit/products': PERMISSIONS.SIXORBIT_READ,
  '/sixorbit/product-master-export': PERMISSIONS.PRICE_READ,
  '/sixorbit/stock-export': PERMISSIONS.STOCK_READ,
  '/sixorbit/sync-log': PERMISSIONS.SIXORBIT_READ,
  '/sixorbit/pending-jobs': PERMISSIONS.SIXORBIT_READ,
  '/settings': PERMISSIONS.SETTINGS_MANAGE,
  '/backup-restore': PERMISSIONS.SETTINGS_MANAGE,
  '/transaction-archive': PERMISSIONS.SETTINGS_MANAGE,
  '/wipe-data': PERMISSIONS.SETTINGS_MANAGE,
  '/access-calendar': PERMISSIONS.SETTINGS_MANAGE,
};

export function canSeeMenu(path: string, permissions: readonly string[], roles: readonly string[], email?: string): boolean {
  if (path === '/transaction-archive' || path === '/wipe-data') return email?.toLowerCase() === 'dinez17@gmail.com' || roles.includes('SUPER_ADMIN');
  if (path === '/backup-restore') return email?.toLowerCase() === 'dinez17@gmail.com' || roles.some(role => ['ADMIN', 'SUPER_ADMIN'].includes(role));
  if (path === '/settings' && (email?.toLowerCase() === 'dinez17@gmail.com' || roles.includes('ADMIN'))) return true;
  if (path === '/access-calendar') {
    return email?.toLowerCase() === 'dinez17@gmail.com';
  }
  const required = MENU_PERMISSIONS[path];
  return Boolean(required && (roles.includes('SUPER_ADMIN') || permissions.includes(required)));
}
